import { discontinuedData } from "../../components/discountinued/discountinued_data";
/**
 * Get manual make data from API.
 *
 * @param {Function} setMakes - A function to set vehicle makes.
 * @param {Function} setLoadingMake - A function to set loading state for makes.
 * @param {Function} setClicked - A function to set clicked state.
 * @param {any} gtMotorServices - The API object for fetching data.
 */

export const getManualMakeApi = (
  setMakes: any,
  setLoadingMake: any,
  setClicked: any,
  emsApiCall: any,
  bodyData: string,
  history: any,
) => {
  setLoadingMake(true);
  emsApiCall(bodyData)
    .then((response: any) => {
      if (response.message === "Unauthorised to perform this action {1}.") {
        localStorage.removeItem("ems-auth-token");
        history.push("/onboarding/1");
      } else {
        setMakes(response.data);
        setClicked(false);
        setLoadingMake(false);
      }
    })
    .catch((e: any) => {
      console.log("error", e);
      setClicked(false);
      setLoadingMake(false);
    });
};

/**
 * Get manual model data from API.
 *
 * @param {Function} setLoadingModel - A function to set loading state for models.
 * @param {Function} setVariants - A function to set vehicle variants.
 * @param {Function} setClicked - A function to set clicked state.
 * @param {any} gtMotorServices - The API object for fetching data.
 */

export const getManualModelApi = (
  setLoadingModel: any,
  setVariants: any,
  setClicked: any,
  emsApiCall: any,
  bodyData: string,
  history: any,
) => {
  setLoadingModel(true);
  emsApiCall(bodyData)
    .then((response: any) => {
      if (
        response.message?.includes("Unauthorised to perform this action {1}.")
      ) {
        localStorage.removeItem("ems-auth-token");
        history.push("/onboarding/1");
        return;
      }

      if (!response.desc) {
        return;
      } else {
        setVariants(response.desc);
        setClicked(false);
        setLoadingModel(false);
      }
    })

    .catch((e: any) => {
      console.log("error", e);
      setClicked(false);
    });
};

export const getModelYearsApi = (
  setLoadingModel: any,
  setClicked: any,
  setVehicleYears: any,
  emsApiCall: any,
  bodyData: string,
) => {
  setLoadingModel(true);
  emsApiCall(bodyData)
    .then((response: any) => {
      if (!response.model_years) {
        alert("Oops\nSomething went wrong please try changing your selection");
      } else {
        let modelYears = response.model_years;

        const currentYear = new Date().getFullYear();

        if (modelYears.length === 1) {
          const startYesr = modelYears[0];
          for (let year = startYesr + 1; year <= currentYear; year++) {
            modelYears.push(year);
          }
        } else {
          const minYears = Math.min(...modelYears);
          for (let year = minYears; year <= currentYear; year++) {
            if (!modelYears.includes(year)) {
              modelYears.push(year);
            }
          }
        }

        modelYears.sort((a: number, b: number) => a - b);

        setVehicleYears(modelYears);
        setClicked(false);
        setLoadingModel(false);
      }
    })

    .catch((e: any) => {
      setClicked(false);
    });
};

export const getModelEngineDataApi = async (
  setLoadingEngine: any,
  setClicked: any,
  setEngineList: any,
  emsApiCall: any,
  bodyData: string,
  modelYears: number[],
  currentYear: number,
) => {
  try {
    let response = await emsApiCall(bodyData);
    let engineData = response?.model_engine || [];

    setEngineList(engineData);
  } catch (error) {
    console.log(
      "Oops\nSomething went wrong please try changing your selection",
      error,
    );
  }
  setLoadingEngine(false);
  setClicked(false);
};

export const getModelGearboxTypeDataApi = async (
  setLoadingGearboxType: any,
  setClicked: any,
  setGearboxTypeList: any,
  emsApiCall: any,
  bodyData: string,
  modelYears: number[],
  currentYear: number,
) => {
  setLoadingGearboxType(true);
  try {
    let response = await emsApiCall(bodyData);
    let gearBoxTypeData = response?.model_gearbox_types || [];

    setGearboxTypeList(gearBoxTypeData);
  } catch (error) {
    console.log(
      "Oops\nSomething went wrong please try changing your selection",
      error,
    );
  } finally {
    setLoadingGearboxType(false);
    setClicked(false);
  }
};

export const getModelGearboxDriveTypeApi = async (
  setLoadingGearboxDrive: any,
  setClicked: any,
  setGearboxDriveList: any,
  emsApiCall: any,
  bodyData: string,
  modelYears: number[],
  currentYear: number,
) => {
  setLoadingGearboxDrive(true);
  try {
    let response = await emsApiCall(bodyData);
    let gearBoxDriveData = response?.model_drive_types || [];

    setGearboxDriveList(gearBoxDriveData);
    setClicked(false);
  } catch (error) {
    console.log(
      "Oops\nSomething went wrong please try changing your selection",
      error,
    );
  } finally {
    setLoadingGearboxDrive(false);
    setClicked(false);
  }
};

const filterMostCurrentVariants = (variants: any[]): any[] => {
  const latestVariants: Record<string, any> = {};

  variants.forEach((variant) => {
    const key = variant.cc2 || variant.umc;
    if (
      !latestVariants[key] ||
      !variant.cc2 ||
      new Date(latestVariants[key].intro_date) < new Date(variant.intro_date)
    ) {
      latestVariants[key] = variant;
      //console.log("Variant: ", latestVariants);
    }
  });
  //console.log("final variant: ", latestVariants);
  return Object.values(latestVariants);
};

export const getModelDetailsApi = async (
  setLoadingModelDetail: any,
  setClicked: any,
  setModelDetail: any,
  emsApiCall: any,
  bodyData: string,
  currentYear: number,
) => {
  setLoadingModelDetail(true);
  try {
    let response = await emsApiCall(bodyData);
    //console.log("the response back: ", response);
    let variantData = response?.all_models || [];
    //console.log("The data: ", variantData);

    variantData = [...variantData].filter(
      (value, index, self) =>
        self.findIndex((v) => v.umc === value.umc) === index,
    );
    //console.log("variant data: ", variantData);

    const filterVariant = filterMostCurrentVariants(variantData);
    //console.log("filtered variant: ", filterVariant);

    const allValidVariants = filterVariant.filter((variant: any) => {
      const discountinuedDates = discontinuedData.find(
        (item: any) => item.MM_CODES === parseInt(variant.cc2),
      );

      if (!discountinuedDates || !discountinuedDates["Discontinued_Date"]) {
        return true;
      }

      const discountinueDate = new Date(
        discountinuedDates["Discontinued_Date"],
      );
      const introDate = new Date(variant.intro_date);

      const modelIsStillValid = currentYear <= discountinueDate.getFullYear();

      /*console.log(
        `Variant: ${variant.variant}, Intro Date: ${introDate}, Discontinue Date: ${discountinueDate}, is Still valid: ${modelIsStillValid}`,
      );*/

      return introDate.getFullYear() <= currentYear && modelIsStillValid;
    });
    // console.log("filtering properly: ", allValidVariants);
    setModelDetail(allValidVariants);
  } catch (error) {
    console.log(
      "Oops\nSomething went wrong please try changing your selection",
      error,
    );
  } finally {
    setLoadingModelDetail(false);
    setClicked(false);
  }
};

// export const getModelEngineDataWithPreviousYears = (setLoadingModelDetail: any, setClicked: any, setModelDetail: any ) => {

// }

/**
 * Calculates the age of a vehicle based on the given year and updates related data.
 *
 * @param {number} year - The manufacturing year of the vehicle.
 * @param {Object} maintenanceEstimateData - The maintenance estimate data object.
 */
export const calculateVehicleAge = (
  year: number,

  setSelectedModelAge: any,
) => {
  const currentYear = new Date().getFullYear();
  const vehicleAge = currentYear - year;
  setSelectedModelAge(vehicleAge);
};

/**
 * Custom make data for selection.
 */
export const customMake = {
  header: "Select Make",
  subHeader: "Scroll to select your vehicle make.",
};

/**
 * Custom model data for selection.
 */
export const customModel = {
  header: "Select Model",
  subHeader: "Scroll to select your vehicle model.",
};

/**
 * Custom year data for selection.
 */
export const customYear = {
  header: "Select Engine Option",
  subHeader: "Scroll to select your engine option.",
};

/**
 * Interface year data for selection.
 */
export const interfaceYear = {
  header: "Select Year",
  subHeader: "Scroll to select your year.",
};

/**
 * Custom gearbox data for selection.
 */
export const customGear = {
  header: "Select Gearbox Option",
  subHeader: "Scroll to select your gearbox option.",
};
